import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ChatInterface from './ChatInterface';
import '../styles/GreenFlagRedFlag.css';

function GreenFlagRedFlag() {
  const { eventId } = useParams();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Set the active event ID in localStorage for ChatInterface to use
    if (eventId) {
      localStorage.setItem('active-event-id', eventId);
      setIsReady(true);
    }
  }, [eventId]);

  if (!isReady) {
    return (
      <div className="game-loading">
        <div className="loader">Loading game...</div>
      </div>
    );
  }

  return (
    <div className="green-flag-red-flag">
      <div className="game-header">
        <Link to="/games" className="back-to-games">← Back to Games</Link>
        <h2>Green Flag Red Flag</h2>
      </div>
      <ChatInterface />
    </div>
  );
}

export default GreenFlagRedFlag;
